.card-background{display:block;width:100%;border-radius:25px;height:461px;object-fit:cover}
/*# sourceMappingURL=call-to-action.component-DVYCW7AN.css.map */
